import React, { useState, useEffect } from 'react';
import axios from 'axios';
import {
  Container,
  TextField,
  Button,
  Box,
  Typography,
  Paper,
} from '@mui/material';
import { useNavigate, useParams } from 'react-router-dom';

const apiUrl = process.env.REACT_APP_API_URL;

const EditReproductionProcedure = () => {
  const { id } = useParams(); // procedure_id
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    procedure_name: '',
    description: '',
    default_price: '',
  });

  /*const fetchProcedure = async () => {
    try {
      const response = await axios.get(
        `${apiUrl}/reproduction-clinic/procedures/${id}`
      );
      setFormData(response.data);
    } catch (error) {
      console.error('❌ Error fetching procedure data:', error);
    }
  };*/

  useEffect(() => {
    const fetchProcedure = async () => {
      try {
        const response = await axios.get(
          `${apiUrl}/reproduction-clinic/procedures/${id}`
        );
        setFormData(response.data);
      } catch (error) {
        console.error('❌ Error fetching procedure data:', error);
      }
    };

    fetchProcedure();
  }, [id]);

  const handleSubmit = async () => {
    try {
      const updatedFormData = {
        ...formData,
        user_id: localStorage.getItem('userId'), // 👈 توثيق المستخدم
      };

      await axios.put(
        `${apiUrl}/reproduction-clinic/procedures/${id}`,
        updatedFormData
      );

      navigate('/ReproductionProceduresList');
    } catch (error) {
      console.error('❌ Error updating procedure:', error);
    }
  };

  return (
    <Container maxWidth="sm" sx={{ mt: 4 }}>
      <Paper elevation={3} sx={{ p: 4 }}>
        <Typography variant="h5" gutterBottom align="center">
          Edit Reproduction Procedure
        </Typography>

        <TextField
          label="Procedure Name"
          fullWidth
          required
          value={formData.procedure_name}
          onChange={(e) =>
            setFormData({ ...formData, procedure_name: e.target.value })
          }
          margin="normal"
        />

        <TextField
          label="Description"
          fullWidth
          multiline
          rows={4}
          value={formData.description}
          onChange={(e) =>
            setFormData({ ...formData, description: e.target.value })
          }
          margin="normal"
        />

        <TextField
          label="Default Price"
          fullWidth
          type="number"
          value={formData.default_price}
          onChange={(e) =>
            setFormData({
              ...formData,
              default_price: parseFloat(e.target.value),
            })
          }
          margin="normal"
        />

        <Box textAlign="center" mt={3}>
          <Button variant="contained" color="primary" onClick={handleSubmit}>
            Save Changes
          </Button>
        </Box>
      </Paper>
    </Container>
  );
};

export default EditReproductionProcedure;
